import { Department } from '../../types/agentTypes';
import { axiosClient } from '../axiosClient';

export const departmentFunctions = {
  fetchDepartmentsList: async (): Promise<Department[]> => {
    return await axiosClient.get('api/departments/')
  },
};
